import useApi from "../useApi";

const useFeedbackService = () => {

  const {api} = useApi()

  const userStore = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'user/feedback/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFeedbackService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data
    )
  }

  return {
    userStore,
  }
}

export default useFeedbackService
